Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.PixelSnapping = module.exports.default = {
	ALWAYS: "always",
	AUTO: "auto",
	NEVER: "never"
};